// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Products} from '../homepage/products';
import styles from './products_lobby.module.less';
import {Manage_product} from './manage_product';

export const Products_lobby = ()=>{
    return <div className={styles.products_lobby}>
      <Products title='Oculus Products' />
      <Manage_product />
    </div>;
};
